import React from 'react'
import './BoostOverview.scss'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { useNavigate } from 'react-router-dom'
import boostWordmark from 'Assets/Images/Dashboard/overview-pages/boost/boost-wordmark.png'
import boostBannerTruck from 'Assets/Images/Dashboard/overview-pages/boost/boost-banner-truck.png'
import arrowUpGreen from 'Assets/Images/Dashboard/overview-pages/boost/arrow-up-green.svg'

type TxStatus = 'Pending' | 'Success'

const BoostOverview = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const name = user?.user?.name ?? 'Admin'

  const tabs: Array<{ label: string; active: boolean; onClick?: () => void }> = [
    { label: 'TradeGrid Boost', active: true },
    {
      label: 'TradersCard',
      active: false,
      onClick: () => navigate('/general-overview/traderscard-overview'),
    },
    {
      label: 'TradeGrid Plus',
      active: false,
      onClick: () => navigate('/general-overview/tgplus-overview'),
    },
    {
      label: 'BoostXpress',
      active: false,
      onClick: () => navigate('/general-overview/boostxpress-overview'),
    },
  ]

  const metrics: Array<{ label: string; value: string; deltaText: string }> = [
    { label: 'Total Orders', value: '1,500', deltaText: '+100 new users' },
    { label: 'Total transaction', value: '5,000,000', deltaText: '+100 Transactions' },
    { label: 'Total Active Users', value: '20 User', deltaText: '+10 new users' },
    { label: 'Total Litres Supplied', value: '200,000L', deltaText: '+100 Liters' },
  ]

  const transactions: Array<{
    amount: string
    date: string
    product: string
    status: TxStatus
  }> = [
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Pending' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
  ]

  const usersList: Array<{ name: string; msisdn: string; acctType: string }> = [
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
  ]

  return (
    <div className='boost-overview-page'>
      <div className='container boost-overview-page__container--'>
        <div className='boost-banner'>
          <div className='boost-banner__content'>
            <div className='boost-banner__welcome'>Welcome Back, {name}</div>
            <div className='boost-banner__subtitle'>Here&apos;s your Boost summary</div>
          </div>
          <img src={boostBannerTruck} className='boost-banner__art' />
        </div>

        <div className='boost-summary-card'>
          <img src={boostWordmark} className='boost-summary-card__logo' />
          <div className='boost-metrics'>
            {metrics.map((m) => (
              <div className='boost-metric' key={m.label}>
                <div className='boost-metric__label'>{m.label}</div>
                <div className='boost-metric__value'>{m.value}</div>
                <div className='boost-metric__delta'>
                  <img src={arrowUpGreen} className='boost-metric__delta-icon' />
                  <span className='boost-metric__delta-up'>5%</span>
                  <span className='boost-metric__delta-text'>{m.deltaText}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='row boost-bottom'>
          <div className='col-12 col-lg-7'>
            <div className='boost-tabs'>
              {tabs.map((t) => (
                <button
                  key={t.label}
                  className={`boost-tab ${t.active ? 'boost-tab--active' : ''}`}
                  type='button'
                  onClick={t.onClick}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div className='boost-section-title'>
              <div className='boost-section-title__left'>Recent Transactions</div>
              <div className='boost-section-title__right'>View all</div>
            </div>

            <div className='boost-table-card'>
              <div className='boost-table-card__head'>
                <div className='boost-table-card__col boost-table-card__col--amount'>Amount</div>
                <div className='boost-table-card__col boost-table-card__col--date'>Date</div>
                <div className='boost-table-card__col boost-table-card__col--product'>Product</div>
                <div className='boost-table-card__col boost-table-card__col--status'>Status</div>
              </div>

              <div className='boost-table-card__body'>
                {transactions.map((tx, idx) => (
                  <div
                    className={`boost-tx-row ${idx % 2 === 0 ? 'boost-tx-row--alt' : ''}`}
                    key={`${tx.product}-${idx}`}
                  >
                    <div className='boost-tx-row__col boost-tx-row__col--amount'>{tx.amount}</div>
                    <div className='boost-tx-row__col boost-tx-row__col--date'>{tx.date}</div>
                    <div className='boost-tx-row__col boost-tx-row__col--product'>{tx.product}</div>
                    <div className='boost-tx-row__col boost-tx-row__col--status'>
                      <div
                        className={`boost-status ${
                          tx.status === 'Pending'
                            ? 'boost-status--pending'
                            : 'boost-status--success'
                        }`}
                      >
                        {tx.status}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-5'>
            <div className='boost-users-card mb-4'>
              <div className='boost-users-card__header'>
                <div className='boost-users-card__title'>Recent Users</div>
                <div className='boost-users-card__action'>View all</div>
              </div>

              <div className='boost-users-card__table'>
                <div className='boost-users-card__row boost-users-card__row--head'>
                  <div className='boost-users-card__cell boost-users-card__cell--name'>Name</div>
                  <div className='boost-users-card__cell boost-users-card__cell--msisdn'>
                    MSISDN
                  </div>
                  <div className='boost-users-card__cell boost-users-card__cell--acct'>
                    Acct.Type
                  </div>
                </div>

                {usersList.map((u, idx) => (
                  <div className='boost-users-card__row' key={`${u.name}-${idx}`}>
                    <div className='boost-users-card__cell boost-users-card__cell--name'>
                      {u.name}
                    </div>
                    <div className='boost-users-card__cell boost-users-card__cell--msisdn'>
                      {u.msisdn}
                    </div>
                    <div className='boost-users-card__cell boost-users-card__cell--acct'>
                      {u.acctType}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='boost-total-users-card'>
              <div className='boost-total-users-card__header'>
                <div className='boost-total-users-card__title'>Total Users</div>
                <div className='boost-total-users-card__action'>View all</div>
              </div>
              <div className='boost-total-users-card__value'>20</div>
              <div className='boost-total-users-card__delta'>
                <img src={arrowUpGreen} className='boost-total-users-card__delta-icon' />
                <span className='boost-total-users-card__delta-up'>5%</span>
                <span className='boost-total-users-card__delta-text'>+100 new users</span>
              </div>
            </div>
          </div>
        </div>

        <div className='boost-footer'>© 2026 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default BoostOverview
